var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Modal from '../../../../../admin-columns/src/js/modules/modal';
var nanobus = require('nanobus');
var SegmentModal = /** @class */ (function (_super) {
    __extends(SegmentModal, _super);
    function SegmentModal(el, segments) {
        var _this = _super.call(this, el) || this;
        _this.segments = segments;
        _this.form = document.querySelector('form#frm_create_segment');
        _this.formelements = _this.form.elements;
        _this.events = nanobus();
        _this.initFormEvents();
        return _this;
    }
    SegmentModal.prototype.initFormEvents = function () {
        var _this = this;
        this.form.addEventListener('submit', function (e) {
            e.preventDefault();
            _this.save();
        });
        this.el.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        this.form.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                _this.form.dispatchEvent(new Event('submit'));
            }
        });
    };
    SegmentModal.prototype.reset = function () {
        this.getNameElement().value = '';
    };
    SegmentModal.prototype.onOpen = function () {
        var _this = this;
        this.reset();
        setTimeout(function () {
            _this.getNameElement().focus();
        }, 100);
    };
    SegmentModal.prototype.finish = function () {
        this.reset();
        this.close();
    };
    SegmentModal.prototype.getNameElement = function () {
        return this.formelements.namedItem('name');
    };
    SegmentModal.prototype.save = function () {
        this.events.emit('save', new FormData(this.form));
    };
    SegmentModal.prototype.setLoading = function (on) {
        if (on === void 0) { on = true; }
        var loading = this.el.querySelector('.ac-modal__loading');
        (on)
            ? loading.style.display = 'inline-block'
            : loading.style.display = 'none';
    };
    SegmentModal.prototype.displayError = function (msg) {
        this.el.querySelector('.ac-modal__error').textContent = msg;
    };
    return SegmentModal;
}(Modal));
export default SegmentModal;
